module.exports = __webpack_public_path__ + "img/apply.7315a0f6.svg";